import { useAuthStore } from '../store/authstore';
import { useInstituteStore } from '../store/institutestore';

/** School name for printed documents — never the product brand. */
export function getPrintSchoolName(): string {
  const brandingName = useInstituteStore.getState().branding.schoolName?.trim();
  const instituteName = useAuthStore.getState().session?.user.instituteName?.trim();
  return brandingName || instituteName || '';
}
